export default __webpack_public_path__ + "static/media/Feinberg-linear-white.9ff668d3.png";